import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import { useHistory } from "react-router";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
import getExcel from "../../../_services/ExcelUtility";
import moment from "moment";
import { Footer } from "../../../components/Footer";

const ProductCatalouge = () => {
	const fileName = "Genentech Sales Source Data (monthly)-857";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	const history = useHistory();
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const headercolumns = [
		{
			Header: "Distributor Branch ID  Type",
			accessor: "DistributionLocationState",
			filter: "DistributionLocationState",
			sortType: "basic",
		},
		{
			Header: "Distributor Branch ID",
			accessor: "DistributorName",
			filter: "DistributorName",
			sortType: "basic",
		},
		{
			Header: "Distributor Branch City",
			accessor: "DistributorBranchCity",
			filter: "DistributorBranchCity",
			sortType: "basic",
		},
		{
			Header: "Account ID Type",
			accessor: "DebitMemoNum",
			filter: "DebitMemoNum",
			sortType: "basic",
		},
		{
			Header: "Account ID",
			accessor: "CustID",
			filter: "CustID",
			sortType: "basic",
		},
		{
			Header: "Org Name",
			accessor: "CustName",
			filter: "CustName",
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Physician Last Name",
			accessor: "",
			filter: "",
			sortType: "basic",
		},
		{
			Header: "Physician First Name",
			accessor: "",
			filter: "",
			sortType: "basic",
		},

		{
			Header: "Account Address 1",
			accessor: "CustAddress",
			filter: "CustAddress",
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Account Address 2",
			accessor: "AccountAddress2",
			filter: "AccountAddress2",
			sortType: "basic",
		},
		{
			Header: "Account City",
			accessor: "CustCity",
			filter: "CustCity",
			sortType: "basic",
			width: 110,
		},

		{
			Header: "Account State",
			accessor: "CustState",
			filter: "CustState",
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Account Zip",
			accessor: "CustZip",
			filter: "CustZip",
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Product NDC Type",
			accessor: "ProductNDCType",
			filter: "ProductNDCType",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "Product NDC",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "PRODUCT DESCRIPTION",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "REF ID TYPE",
			accessor: "RefIDType",
			filter: "RefIDType",
			sortType: "basic",
			width: 100,
		},
		{
			Header: "INVOICE #",
			accessor: "CustomersInvoice",
			filter: "CustomersInvoice",
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Qty",
			accessor: "SaleQTY",
			filter: "SaleQTY",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "UOM",
			accessor: "SaleQTYUOM",
			filter: "SaleQTYUOM",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Shipped Date",
			accessor: "CustomersInvoiceDate",
			filter: "CustomersInvoiceDate",
			sortType: "basic",
			width: 120,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Product Transfer Indicator",
			accessor: "ProductTransferIndicator",
			filter: "ProductTransferIndicator",
			sortType: "basic",
		},
		{
			Header: "Drop Shipped Indicator",
			accessor: "DropShippedIndicator",
			filter: "DropShippedIndicator",
			sortType: "basic",
		},
	];

	useEffect(() => {
		getProducts();
	}, []);

	async function getProducts() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const salesSource = data.data;
				if (salesSource.length > 0) {
					salesSource.map((res) => {
						res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format(
							"MM/DD/YYYY"
						);
					});
				}
				setLoading(false);
				setProducts(salesSource);
			})
			.catch((e) => {
				setLoading(false);
				setHasError(true);
			});
	}

	const EditRecords = () => {
		localStorage.setItem("products", JSON.stringify(products));
		history.push("/GenentechSalesEdit");
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				<div>
					{products.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ? (
							<Button type="submit" onClick={() => EditRecords()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EditRecords()}>
								Edit Records
							</Button>
						))}
					<Button
						type="submit"
						className="ml-2"
						onClick={() => getExcel(headercolumns, products, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>Error occurred. Unable to load {fileName}</p>
								) : (
									<Fragment>
										{loading ? (
											<Loader />
										) : products.length > 0 ? (
											<ReactTable
												columns={headercolumns}
												data={products}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default ProductCatalouge;
